// src/components/EnhancedTalentRiskDashboard.tsx
import React, { useState, useEffect } from 'react';
import Header from './shared/Header';
import './styles/EmployeeDashboard.css'; // Keep your existing dashboard styles

const EnhancedTalentRiskDashboard: React.FC = () => {
  const [dashboardData, setDashboardData] = useState<any>(null);
  
  // Your existing dashboard logic here...
  useEffect(() => {
    // Fetch dashboard data
    const fetchDashboardData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/advanced-risk/dashboard-metrics`);
        const data = await response.json();
        setDashboardData(data);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        // Use mock data or fallback
      }
    };
    
    fetchDashboardData();
  }, []);
  
  return (
    <div className="dashboard-page">
      {/* Prometheus Header with Logo */}
      <Header 
        showNav={true}
        title="PROMETHEUS"
        subtitle="Risk Intelligence Dashboard"
      />
      
      <main className="dashboard-content">
        {/* Your existing dashboard content */}
        <div className="dashboard-header">
          <h1>Talent Risk Intelligence Dashboard</h1>
          <p className="dashboard-subtitle">
            Real-time predictive analytics for employee retention
          </p>
        </div>
        
        {/* Metrics Grid */}
        <div className="metrics-grid">
          <div className="metric-card">
            <div className="metric-title">High Risk Employees</div>
            <div className="metric-value">{dashboardData?.highRiskCount || 53}</div>
            <div className="metric-trend">↑ 12% this month</div>
          </div>
          
          <div className="metric-card">
            <div className="metric-title">Overall Risk Score</div>
            <div className="metric-value">{dashboardData?.overallRiskScore || 41}</div>
            <div className="metric-trend">↓ 8% from last month</div>
          </div>
          
          <div className="metric-card">
            <div className="metric-title">Departments Monitored</div>
            <div className="metric-value">{dashboardData?.departmentCount || 10}</div>
            <div className="metric-trend">All departments active</div>
          </div>
          
          <div className="metric-card">
            <div className="metric-title">Total Employees</div>
            <div className="metric-value">{dashboardData?.totalEmployees || 247}</div>
            <div className="metric-trend">+5 new hires</div>
          </div>
        </div>
        
        {/* Risk Distribution */}
        <div className="risk-distribution-section">
          <h2>Risk Distribution</h2>
          <div className="risk-bars">
            <div className="risk-bar-item">
              <div className="risk-label">Critical</div>
              <div className="risk-bar critical" style={{ width: '15%' }}></div>
              <div className="risk-value">23</div>
            </div>
            <div className="risk-bar-item">
              <div className="risk-label">High</div>
              <div className="risk-bar high" style={{ width: '30%' }}></div>
              <div className="risk-value">30</div>
            </div>
            <div className="risk-bar-item">
              <div className="risk-label">Medium</div>
              <div className="risk-bar medium" style={{ width: '38%' }}></div>
              <div className="risk-value">38</div>
            </div>
            <div className="risk-bar-item">
              <div className="risk-label">Low</div>
              <div className="risk-bar low" style={{ width: '17%' }}></div>
              <div className="risk-value">17</div>
            </div>
          </div>
        </div>
        
        {/* Department Analysis */}
        <div className="department-section">
          <h2>Department Risk Analysis</h2>
          <div className="department-grid">
            <div className="department-card">
              <div className="dept-name">Engineering</div>
              <div className="dept-risk-score">68</div>
              <div className="dept-trend high">High Risk</div>
            </div>
            <div className="department-card">
              <div className="dept-name">Sales</div>
              <div className="dept-risk-score">54</div>
              <div className="dept-trend medium">Medium Risk</div>
            </div>
            <div className="department-card">
              <div className="dept-name">Marketing</div>
              <div className="dept-risk-score">42</div>
              <div className="dept-trend medium">Medium Risk</div>
            </div>
            <div className="department-card">
              <div className="dept-name">HR</div>
              <div className="dept-risk-score">28</div>
              <div className="dept-trend low">Low Risk</div>
            </div>
          </div>
        </div>
        
        {/* Action Items */}
        <div className="actions-section">
          <h2>Recommended Actions</h2>
          <div className="actions-list">
            <div className="action-item">
              <div className="action-icon">���</div>
              <div className="action-content">
                <div className="action-title">Retention Planning for Engineering</div>
                <div className="action-description">Schedule 1-on-1s with high-risk engineers</div>
              </div>
              <button className="action-button">Plan</button>
            </div>
            <div className="action-item">
              <div className="action-icon">���</div>
              <div className="action-content">
                <div className="action-title">Salary Review for Sales Team</div>
                <div className="action-description">Competitive analysis shows 15% below market</div>
              </div>
              <button className="action-button">Review</button>
            </div>
          </div>
        </div>
      </main>
      
      {/* Footer */}
      <footer className="dashboard-footer">
        <div className="footer-logo">
          <div className="footer-logo-image">
            <img 
              src="/resources/prometheus_logo.jpg" 
              alt="Prometheus"
              style={{ width: '40px', height: '40px', borderRadius: '10px' }}
            />
          </div>
          <div className="footer-text">
            <div className="footer-title">Prometheus Workforce Analytics</div>
            <div className="footer-subtitle">Real-time predictive risk intelligence</div>
          </div>
        </div>
        <div className="footer-info">
          <div className="footer-stat">
            <div className="stat-value">247</div>
            <div className="stat-label">Employees Protected</div>
          </div>
          <div className="footer-stat">
            <div className="stat-value">95%</div>
            <div className="stat-label">Prediction Accuracy</div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default EnhancedTalentRiskDashboard;
